import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { importProvidersFrom, inject, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { CanActivateFn, provideRouter, Router, Routes, withInMemoryScrolling } from '@angular/router';
import { AppComponent } from './app/app.component';

import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';
import { API_BASE_URL } from './app/api.service.gen';
import { MeStore } from './app/auth.me.store';
import { LoginComponent } from './app/login/login';
import { ReadmeComponent } from './app/readme/readme';
import { UnauthorizedInterceptor } from './app/interceptors/unauthorized.interceptor';
import { AuthorizeComponent } from './app/authorize/authorize';
import { ClaudeDesktop } from './app/claude-desktop/claude-desktop';
import { CopilotStudio } from './app/copilot-studio/copilot-studio';
import { CopilotVsCode } from './app/copilot-vs-code/copilot-vs-code';
import { ChatGPT } from './app/chatgpt/chatgpt';

const authenticated: CanActivateFn = () => {
  const store = inject(MeStore);
  const router = inject(Router);
  if (store.isAuthenticated())
    return true
  return toObservable(store.isAuthenticated).pipe(
    filter((val) => val !== null),
    map(b => b ? true : router.createUrlTree(["/login"]))
  );
};

export const routes: Routes = [
  { path: 'readme', component: ReadmeComponent},
  { path: 'claude', component: ClaudeDesktop},
  { path: 'copilot-vs-code', component: CopilotVsCode},
  { path: 'copilot-studio', component: CopilotStudio},
  { path: 'chatgpt', component: ChatGPT},
  { path: 'app', loadChildren: () => import('./app/todoapp/todoapp.module').then(m => m.TodoAppModule), canActivate: [authenticated]},
  { path: '', redirectTo: '/readme', pathMatch: 'full'},
  { path: 'login', component: LoginComponent },
  { path: 'authorize', component: AuthorizeComponent },
  { path: '**', redirectTo: '/readme'}
];

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(BrowserModule),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true },
    { provide: API_BASE_URL, useValue: '' },
  ]
}).catch(err => console.error(err));